// Issues Tracker numbers on the project dashboard (A2 "Statistics" card). Data: project_dashboard().issues —
// the same issues.project_stats() the A3 overview uses, so both always agree (tested in tests/db).
// "Signed off" counts COMPONENTS (code list #2), e.g. 2 / 12.
import type { Discipline, IssueStats } from "../../../core/api/types";

export function IssuesKpis({ stats }: { stats: IssueStats }) {
  const kpi = (label: string, value: string | number, tone: string, testid?: string) =>
    <div className={`kpi ${tone}`} data-testid={testid}><p className="k">{label}</p><p className="v">{value}</p></div>;
  return (
    <div className="kpis" data-testid="issues-kpis">
      {kpi("Total open", stats.open_total, "", "kpi-open")}
      {kpi("Critical", stats.critical, "red")}
      {kpi("Overdue", stats.overdue, "red", "kpi-overdue")}
      {kpi("Awaiting sign-off", stats.awaiting_signoff, "amber")}
      {kpi("Signed off", `${stats.signed_off} / ${stats.components}`, "green", "kpi-signed")}
    </div>
  );
}

export function OpenByDiscipline({ stats, disciplines }: { stats: IssueStats; disciplines: Discipline[] }) {
  const max = Math.max(1, ...disciplines.map((d) => stats.open_by_discipline[d.code] ?? 0));
  return (
    <div className="disc-bars two-col">
      <p className="mini-label">Open by discipline</p>
      {disciplines.map((d) => {
        const n = stats.open_by_discipline[d.code] ?? 0;
        return (
          <div key={d.code} className="disc-bar">
            <span style={{ color: d.colour }}>{d.code}</span>
            <div className="track"><div style={{ width: `${Math.round((n / max) * 100)}%`, background: d.colour }} /></div>
            <span className="n">{n}</span>
          </div>
        );
      })}
    </div>
  );
}
